import { datadogRum } from "@datadog/browser-rum";
export function trackAction(name, data) {
    datadogRum.addAction(name, data);
}
